/**
 * useOnboardingCompletionFlag Hook
 *
 * DEPRECATED: This module is being phased out in favor of AuthContext state management.
 * Use AuthContext's updateOnboardingCompleted() instead of these functions.
 *
 * The onboarding completion state is now managed in AuthContext to avoid race conditions
 * and provide proper React state management.
 */

/**
 * @deprecated Use AuthContext updateOnboardingCompleted(true) instead
 */
export function setOnboardingCompletionFlag(): void {
  // No-op - functionality moved to AuthContext
}

/**
 * @deprecated Check onboardingCompleted from AuthContext instead
 */
export function readOnboardingCompletionFlag(): boolean {
  return false; // Always return false - AuthContext is source of truth
}

/**
 * @deprecated Use AuthContext updateOnboardingCompleted(false) instead
 */
export function clearOnboardingCompletionFlag(): void {
  // No-op - functionality moved to AuthContext
}
